<template>
  <el-tooltip placement="top-start" trigger="hover" trig effect="customized" popper-class="feature-tooltip">
    <div class="feature-tag">
      <svg-icon name="icon-feature" />
      <p class="tag-text"> {{ $t('featured') }}</p>
    </div>
    <template #content>
      <div class="feature-text">
        {{$t('featuredTooltip')}}
      </div>
    </template>
  </el-tooltip>
</template>

<style lang="postcss" scoped>
  .feature-tag {
    font-size: 14px;
    padding: 3px 4px;
    color: var(--color-text-description);
    margin-top: 8px;
    height: 17px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    border-radius: 2px;
    background: var(--tag-background);
    width: fit-content;
    cursor: pointer;
    .icon-feature {
      width: 14px;
      height: 14px;
      margin-right: 2px;
      color: var(--color-text-description);
    }
  }

  .feature-text {
    padding: 2px 6px;
    max-width: 212px;
    font-size: 14px;
    color: var(--color-text-secondary);
  }

  @media screen and (max-width: 1023px) {
    .feature-tag {
      padding: 3px 0 3px 2px;
      margin-top: 6px;
      height: 14px;
      .tag-text{
        font-size: 12px;
        -webkit-transform: scale(0.83);
        /* margin-left: -1.7%; */
        margin-left: -3%;
      }
      .icon-feature {
        width: 10px;
        height: 10px;
        margin-right: 0;
      }
    }
  }
</style>
<style>
  .feature-tooltip {
    box-shadow: 0 2px 12px rgba(50, 50, 51, .12);
    background: var(--color-background-secondary);
  }

  .feature-tooltip .el-popper__arrow {
    display: block !important;
  }

  .feature-tooltip .el-popper__arrow::before {
    background: var(--color-background-secondary);
  }
</style>